import { Box } from '@mui/material';

import { TreatmentPlanV3PageHeader } from '../../../pages/treatmentPlanV3/components/header/pageHeader';
import { HeaderActions, HeaderTitleArea } from './components';
import { APP_HEADER_SX } from './styles';
import { useHeaderViewModel } from './hooks';

function Header() {
  const {
    author,
    bay,
    child,
    created,
    headerTreatmentPlanId,
    i18n,
    isMobile,
    isTreatmentPlanV3Header,
    pageId,
    pageIdPrefix,
    pathname,
    provider,
    providerLoading,
    showHeaderMetadata,
    showQuestionnaireHeader,
    status,
    t,
    title,
    user,
    userState,
  } = useHeaderViewModel();

  const headerActions = (
    <HeaderActions
      i18n={i18n}
      pathname={pathname}
      provider={provider}
      providerLoading={providerLoading}
      t={t}
      user={user}
      userState={userState}
    />
  );

  if (isTreatmentPlanV3Header) {
    return <TreatmentPlanV3PageHeader>{headerActions}</TreatmentPlanV3PageHeader>;
  }

  return (
    <Box data-testid="appHeader" sx={APP_HEADER_SX}>
      <HeaderTitleArea
        author={author}
        bay={bay}
        child={child}
        created={created}
        headerTreatmentPlanId={headerTreatmentPlanId}
        isMobile={isMobile}
        pageId={pageId}
        pageIdPrefix={pageIdPrefix}
        showHeaderMetadata={showHeaderMetadata}
        showQuestionnaireHeader={showQuestionnaireHeader}
        status={status}
        t={t}
        title={title}
      />
      {headerActions}
    </Box>
  );
}

export default Header;
